<template>
  <div>
    <div class="list-analytics analysis-chart" v-show="mainChartVisible">
      <div class="t-chart c-pointer">
        <div class="title corner" @click="onClickAddButton">
            전류
            <div :class="addButtonIconName"></div>
        </div>
        <w-plot-line-chart ref="frtCurrentChart" :active="active" :visible="mainChartVisible" :rscInfoList="mainRscInfoList" @clickChart="onClickChart"/>
      </div>
    </div>

    <div class="list-analytics analysis-chart" v-show="subChartVisible">
      <div class="t-chart">
        <div class="title">입력 전류</div>
        <w-plot-line-chart ref="frtInputCurChart" :active="active" :visible="subChartVisible" :rscInfoList="subRscInfo['INPUT_CURRENT']" @clickChart="onClickChart"/>
      </div>
    </div>
  </div>
</template>

<script>
import { performanceChart } from '@/mixins/performance/charts';
import WPlotLineChart from '@/views/performance/node/analysis/components/PlotLineChart';

export default {
  name: 'WFrtCurrentAnalysisChart',
  components: { WPlotLineChart },
  mixins: [performanceChart],
  props: {
    chartVisible: Boolean,
  },
  data() {
    return {
      mainRscInfoList: [
        { rsctypeId: 'FRT', rscId: 'DC_CURRENT', rscKey: '_' },
        { rsctypeId: 'FRT', rscId: 'BATTERY_CURRENT', rscKey: '_' },
        { rsctypeId: 'FRT', rscId: 'LOAD_VOLTAGE', rscKey: '_' },
      ],
      subRscInfo: {
        // FIXME: 자원 데이터 어떻게 보낼지 수정 필요
        INPUT_CURRENT: [{ rsctypeId: 'FRT', rscId: '', rscKey: '_' }],
      },
      subChartVisible: false,
      addButtonIconName: 'triangle add',
    };
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/sensor/components/chart/FrtCurrentAnalysisChart.vue